import styles from './Modal.module.css'

export const Modal = ({ data, setModalData }) => {
  return (
    <div className={styles.modalWrapper}>
      <div className={styles.modalOverlay} onClick={() => setModalData(null)}></div>
      <img className={styles.image} src={data.img} />
    </div>
  )
}
